import React, {useEffect, useState} from "react";

import {Card, Col} from "react-bootstrap";

import TableList from "../../components/table/TableList";
import tableDataModules from "../../controller/tableDataModules";
import {useOutletContext} from "react-router-dom";

const pathToViewer = "http://130.88.233.193/inholland/viewer.html?patient=";
function GoldenStandard() {


    const [GSrows,setGSrows] = useState([]);
    const [GSselected,selectGS] = useState(null);

    const [caseData]  = useOutletContext();//caseid

    let fullname = 'EMPTY';

    if(caseData != null){
        fullname = caseData.module.name+'_'+caseData.name;
    }

    useEffect(()=>{
        tableDataModules.getGoldenStandards(fullname).then(val => {

            const cleanArray = []
            for (let i = 0; i < val.data.length; i++) {
                cleanArray.push([val.data[i].ImageID]);
            }
            if(val.length !== 0){
                selectGS(cleanArray[0]);

            }
            setGSrows(cleanArray);
        })
    }, [fullname]);

    return(
        <>
            <Col xs={{span: 4}}>
                <Card >
                    <Card.Body>
                        <h4>Golden Standard</h4>
                        <TableList columnData={tableDataModules.getColumnsGoldenStandard()} rowData={GSrows}/>
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={{span: 6}} className="p-0">
                <Card >
                    <Card.Body>
                        {GSselected ? <iframe width={630} height={650} src={pathToViewer+fullname+"&GSname="+GSselected} title="Viewer"></iframe>: ''}

                    </Card.Body>
                </Card>
            </Col>

        </>
    )
}

export default GoldenStandard;